import { render, staticRenderFns } from "./LmLicenses.vue?vue&type=template&id=f0d96bf6"
import script from "./LmLicenses.vue?vue&type=script&lang=js"
export * from "./LmLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports